// import React from 'react'

import { unsetToken } from '../../services/authService'

export default ({ history }) => {
  unsetToken()
  history.replace('/auth/signin')
  return null
}
